import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'react-emotion';

class Overlay extends React.Component {
  
    handleClose = (e) => {
      this.props.close(e);
    }
  
    render() {
      const { children } = this.props;
      return (
        <React.Fragment>
          <div className={overlay} onClick={this.handleClose} />
          {children}
        </React.Fragment>
      );
    }
  }
  
  Overlay.propTypes = {
    children: PropTypes.any.isRequired,
    close: PropTypes.func.isRequired
  };

  export default Overlay;
  
  const overlay = css`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: transparent;
    z-index: 3;
  `;


// WEBPACK FOOTER //
// ./src/components/Overlay.jsx